var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccessInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4994 8.91699C22.1693 8.91699 8.91602 22.1703 8.91602 38.5003C8.91602 54.8303 22.1693 68.0837 38.4994 68.0837C54.8293 68.0837 68.0827 54.8303 68.0827 38.5003C68.0827 22.1703 54.8293 8.91699 38.4994 8.91699ZM38.4994 53.292C36.8723 53.292 35.541 51.9607 35.541 50.3337V38.5003C35.541 36.8732 36.8723 35.542 38.4994 35.542C40.1264 35.542 41.4577 36.8732 41.4577 38.5003V50.3337C41.4577 51.9607 40.1264 53.292 38.4994 53.292ZM41.4577 29.6253H35.541V23.7087H41.4577V29.6253Z",
    fill: "#023E7D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 38.25,
    stroke: "#023E7D",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessInfo);
export default __webpack_public_path__ + "static/media/access-info.865a67bfb8f79ad35c5d39443968d50d.svg";
export { ForwardRef as ReactComponent };